import { supabase } from '../supabaseClient'

export async function logTaskEvent({
  taskId = null,
  recurringTaskId = null,
  userId = null,
  eventType,
  fromStatusId = null,
  toStatusId = null,
  eventReason = null,
  metadata = {}
}) {

  const { error } = await supabase
    .from('task_events')
    .insert([{
      task_id: taskId,
      recurring_task_id: recurringTaskId,
      user_id: userId,
      event_type: eventType,
      from_status_id: fromStatusId,
      to_status_id: toStatusId,
      event_reason: eventReason,
      metadata
    }])

  if (error) {
    console.error('Task Event Error:', error)
  }
}